/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
/*
 * Discount badge value helper (JS side of the "Discount badges" theme setting).
 * Mirrors snippets/desk_discount-badge.liquid for badges updated client-side
 * (add-ons, add-on popup, variant price line).
 *
 * window.deskDiscountFormat ('percent' | 'amount') is set inline in
 * theme_body_scripts.liquid from settings.discount_badge_format.
 *
 * window.deskDiscountBadge(discountPct, priceStr, compareStr) -> badge text ('' hides it):
 *   percent -> '-20%'  (from discountPct)
 *   amount  -> '-£40'  (compareStr - priceStr, formatted like the input money strings)
 */

function deskPriceToNumber(str) {
  if (str == null) return 0;
  // Locale-agnostic: works for both "1,099.00" (UK/US: comma=thousands, dot=decimal)
  // and "1.099,00" / "1 099,00" (DE/SE/etc: dot|space=thousands, comma=decimal).
  var s = String(str).replace(/[^\d.,-]/g, '');
  if (!s) return 0;
  var neg = s.charAt(0) === '-';
  s = s.replace(/-/g, '');
  // The LAST '.'/',' is the decimal separator only if 1-2 digits follow it; otherwise
  // every separator is a thousands separator (e.g. "1,099" / "1.099" = 1099, no decimals).
  var lastSep = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
  var intPart, fracPart = '';
  if (lastSep === -1) {
    intPart = s;
  } else if (s.length - lastSep - 1 >= 1 && s.length - lastSep - 1 <= 2) {
    intPart = s.slice(0, lastSep).replace(/[.,]/g, '');
    fracPart = s.slice(lastSep + 1);
  } else {
    intPart = s.replace(/[.,]/g, '');
  }
  var n = parseFloat(intPart + (fracPart ? '.' + fracPart : ''));
  if (isNaN(n)) return 0;
  return neg ? -n : n;
}

function deskFormatMoneyLike(amount, sample) {
  // Reuse the currency symbol / placement from a formatted sample (e.g. "£40", "40 kr", "40 €").
  var s = String(sample == null ? '' : sample);
  var prefix = (s.match(/^[^\d]*/) || [''])[0];
  var suffix = (s.match(/[^\d]*$/) || [''])[0];
  // Preserve the sample's decimal separator ("£40.00" -> '.', "40,00 €" -> ',').
  var decMatch = s.match(/([.,])\d{2}\b/);
  var num = decMatch ? amount.toFixed(2).replace('.', decMatch[1]) : String(Math.round(amount));
  return prefix + num + suffix;
}

function deskDiscountBadge(discountPct, priceStr, compareStr) {
  if (window.deskDiscountFormat === 'amount') {
    var saved = deskPriceToNumber(compareStr) - deskPriceToNumber(priceStr);
    if (!(saved > 0)) return '';
    return '-' + deskFormatMoneyLike(saved, compareStr);
  }
  var pct = parseInt(discountPct, 10) || 0;
  return pct > 0 ? '-' + pct + '%' : '';
}

// Bare value (no leading '-') for badges that embed it in "Sale X" text — e.g. the
// shop-all-products sale badge: returns '20%' or '£40'.
function deskDiscountBadgeValue(discountPct, priceStr, compareStr) {
  if (window.deskDiscountFormat === 'amount') {
    var saved = deskPriceToNumber(compareStr) - deskPriceToNumber(priceStr);
    if (!(saved > 0)) return '';
    return deskFormatMoneyLike(saved, compareStr);
  }
  var pct = parseInt(discountPct, 10) || 0;
  return pct > 0 ? pct + '%' : '';
}

window.deskPriceToNumber = deskPriceToNumber;
window.deskFormatMoneyLike = deskFormatMoneyLike;
window.deskDiscountBadge = deskDiscountBadge;
window.deskDiscountBadgeValue = deskDiscountBadgeValue;
